function customErrorPopup(message) {
    const popup = document.createElement('div');

    popup.textContent = message;

    Object.assign(popup.style, {
        position: 'fixed',
        top: 'auto',
        bottom: '16px',
        left: '16px',
        background: '#e74c3c',
        color: '#fff',
        padding: '16px 24px',
        boxShadow: '0 4px 10px rgba(0,0,0,.2)',
        zIndex: '9999',
        opacity: '0',
        transform: 'translateX(-100%)',
        transition: 'all 0.5s ease'
    });
    document.body.appendChild(popup);
    Object.assign(popup.style, {
        opacity: '1',
        transform: 'translateX(0)',
    });

    setTimeout(() => {
        popup.style.opacity = '0';
        setTimeout(() => {
            popup.remove();
        }, 300);
    }, 4700);
}

function openMinicart() {
    const drawer = /** @type {any} */ (document.querySelector('cart-drawer-component'));

    if (drawer && typeof drawer.open === 'function') {
        drawer.open();
    }
}
function refreshMinicart(quantity = 1) {
    document.dispatchEvent(
        new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
                data: {
                    itemCount: quantity,
                    source: 'product-form-component'
                }
            }
        })
    );
}

function customAddMultipleToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: items
    })
  })
  .then(res => res.json())
  .then(data => {
    console.log('Ajout multiple OK :', data);
    if (data.status) {
        customErrorPopup(data.message);
    } else {
        const totalQuantity = items.reduce((sum, item) => sum + (item.quantity || 1), 0);
        refreshMinicart(totalQuantity);
        openMinicart();
    }
    return data;
  })
  .catch(err => {
    console.error('Erreur ajout multiple :', err);
    customErrorPopup(err.message);
  });
}

function customAddToCart(variantId, quantity = 1, properties = {}) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: properties
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Produit ajouté au panier :', data);
    if (data.status) {
        customErrorPopup(data.message);
    } else {
        refreshMinicart(quantity);
        openMinicart();
    }
    return data;
  })
  .catch(error => {
    console.error('Erreur ajout panier :', error);
    customErrorPopup(error.message);
  });
}

const modifHeader = () => {
    const headerContainer = document.querySelector('.custom-header-container');
    const floatingContainer = headerContainer?.querySelector(".floating-logo-container");
    const floatingContainerBottom = floatingContainer?.getBoundingClientRect().bottom;
    const firstSection = document.querySelector('#MainContent section:first-of-type');
    const firstSectionBottom = firstSection?.getBoundingClientRect().bottom;

    if (floatingContainerBottom && firstSectionBottom) {
        if (floatingContainerBottom > firstSectionBottom) {
            headerContainer?.classList.add('hide-floating');
        } else {
            headerContainer?.classList.remove('hide-floating');
        }
    }
}
const headerPosTop = () => {
    const isScrollLocked = document.body.style.position === 'fixed';
    const scrollTop = isScrollLocked
        ? Math.abs(parseInt(document.body.style.top || '0', 10))
        : window.scrollY;
    const announcementBarHeight = document.querySelector("#header-group .announcement-bar")?.getBoundingClientRect().height;
    const value = scrollTop <= announcementBarHeight ? announcementBarHeight - scrollTop - 1 : 0;

    document.documentElement.style.setProperty('--header-position-top', `${value}px`);
    modifHeader();
}
window.addEventListener("load", headerPosTop);
window.addEventListener('scroll', headerPosTop);
headerPosTop();

function customRestartVideo(id) {
    const video = document.getElementById(id);

    if (video) {
        video.currentTime = 0;
        video.play();
    }
}
function customPlayPauseVideo(id) {
    const video = document.getElementById(id);

    if (video) {
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    }
}
function customMuteVideo(id) {
    const video = document.getElementById(id);

    if (video) {
        video.muted = !video.muted;
    }
}

function formatDate(query) {
    if (!query) return '';

    const date = new Date(query);

    return new Intl.DateTimeFormat('fr-FR', {
        dateStyle: 'full',
        timeStyle: 'short'
    }).format(date);
}

function initReadmore() {
    var maxChars = 200;
    if (window.innerWidth < 1024) {
        maxChars = 300;
    } else {
        maxChars = 300;
    }
    const containers = document.querySelectorAll('.read-more-container');

    containers?.forEach((container) => {
        const content = container.querySelector(".read-more-content");
        const button = container.querySelector(".read-more-btn");
        const fullTextHtml = content?.innerHTML;
        const fullText = content?.textContent.trim();
        let truncatedText = fullText;

        if (fullText.length <= maxChars) {
            return;
        } else {
            container.setAttribute("data-expanded", "false");
            truncatedText = readmoreTruncate(fullText, maxChars);
        }

        content.dataset.fulltext = fullTextHtml;
        content.textContent = truncatedText;

        button.style.display = "inline-block";
        button.addEventListener("click", () => {
            if (container.getAttribute("data-expanded") === "false") {
                container.setAttribute("data-expanded", "true");
                content.innerHTML = fullTextHtml;
                if (document.documentElement.lang == 'fr') {
                    button.textContent = "Voir moins";
                } else {
                    button.textContent = "Read less";
                }
            } else {
                container.setAttribute("data-expanded", "false");
                content.innerHTML = truncatedText;
                if (document.documentElement.lang == 'fr') {
                    button.textContent = "Voir plus";
                } else {
                    button.textContent = "Read more";
                }
            }
        });
    });
}
function readmoreTruncate(str, limit) {
    let result = str.slice(0, limit);

    // Cherche la dernière fin de phrase avant la limite
    const lastSentenceEnd = Math.max(
        result.lastIndexOf("."),
        result.lastIndexOf("!"),
        result.lastIndexOf("?")
    );

    // Si on trouve une fin de phrase, on coupe ici
    if (lastSentenceEnd > 0) {
        result = result.slice(0, lastSentenceEnd + 1);
    } else {
    // Sinon coupe au dernier espace
        result = result.slice(0, result.lastIndexOf(" "));
        result += "...";
    }
    return result;
}
document.addEventListener('DOMContentLoaded', function () { initReadmore() });

async function initMeteoMarseille() {
    try {
        const response = await fetch('https://api.open-meteo.com/v1/forecast?latitude=43.2965&longitude=5.3698&current=temperature_2m,weather_code');
        const data = await response.json();
        const temp = Math.round(data.current.temperature_2m);

        document.querySelector('#temperature-marseille').textContent = `${temp}°C`;
    } catch (error) {
        console.error(error);
  }
}
document.addEventListener('DOMContentLoaded', function () { initMeteoMarseille() });

function handleCookiePopup() {
    const toggler = document.querySelector("a[href='#open-popup-cookies']");

    if (toggler) {
        toggler.addEventListener("click", () => {
            const popup = document.getElementById('axeptio_main_button');
            if (popup) {
                popup.style.display = "block";
            }
        });
    }
}
document.addEventListener('DOMContentLoaded', function () { handleCookiePopup() });

function openSizeGuide(query) {
    const type = query;
    var size_guide;

    if (type == "bracelet") {
        size_guide = document.getElementById("size-guide-popup-bracelet");
    } else if (type == "ring") {
        size_guide = document.getElementById("size-guide-popup-ring");
    }
    if (size_guide) {
        size_guide.classList.add("open");
        document.body.style.overflow = 'hidden';
    }
}
function closeSizeGuide(query) {
    const type = query;
    var size_guide;

    if (type == "bracelet") {
        size_guide = document.getElementById("size-guide-popup-bracelet");
    } else if (type == "ring") {
        size_guide = document.getElementById("size-guide-popup-ring");
    }
    if (size_guide) {
        size_guide.classList.remove("open");
        document.body.style.overflow = '';
    }
}